import {GridEvent, GridEventType} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridEvent';
import {RowIndex, VisibleColumnKeys} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';

export class GridCleared extends GridEvent
{
    constructor()
    {
        super(GridEventType.DataCleared);
    }
}

export class GridRowsCleared extends GridEvent
{
    constructor()
    {
        super(GridEventType.RowsCleared);
    }
}

export class GridInitialRowsAdded extends GridEvent
{
    constructor(public readonly fromRowIndex:number,
                public readonly toRowIndex:number)
    {
        super(GridEventType.InitialRowsAdded);
    }
}

export class GridRowsAdded extends GridEvent
{
    constructor(public readonly fromRowIndex:number,
                public readonly toRowIndex:number)
    {
        super(GridEventType.RowsAdded);
    }
}

export class GridColumnsAdded extends GridEvent
{
    constructor(public readonly fromColumnIndex:number,
                public readonly toColumnIndex:number)
    {
        super(GridEventType.ColumnsAdded);
    }
}

export class GridRowSelectionChanged extends GridEvent
{
    constructor(public readonly rowIndex:RowIndex,
                public readonly isRowSelected:boolean)
    {
        super(GridEventType.RowSelectionChanged);
    }
}

export class GridRowsAndColumnsAdded extends GridEvent
{
    constructor(public readonly fromRowIndex:number,
                public readonly toRowIndex:number,
                public readonly fromColumnIndex:number,
                public readonly toColumnIndex:number)
    {
        super(GridEventType.RowsAndColumnsAdded);
    }
}

export class GridColumnWidthChanged extends GridEvent
{
    constructor(public readonly columnIndex:number)
    {
        super(GridEventType.ColumnWidthChanged);
    }
}

export class GridColumnsFilterChanged extends GridEvent
{
    constructor(public readonly oldFilter:VisibleColumnKeys,
                public readonly newFilter:VisibleColumnKeys)
    {
        super(GridEventType.ColumnsFilterChanged);
    }
}

export class GridIsTransposedChanged extends GridEvent
{
    constructor(public readonly isTransposed:boolean)
    {
        super(GridEventType.IsTransposedChanged);
    }
}
